import React from 'react';
import { AppLayout, PresenceBar } from '@byscott-io/corebyscott';
import { usePresenceRoster } from '@byscott-io/where-is-waldo';

const navItems = [
  { path: '/app', label: 'Dashboard', icon: '🏠' },
  { path: '/app/apps', label: 'Apps', icon: '📱' },
  { path: '/app/affiliates', label: 'Affiliates', icon: '🤝' },
  { path: '/app/admin', label: 'Admin', icon: '⚙️', adminOnly: true },
  { path: '/app/support', label: 'Support', icon: '🎫' },
];

// Who else from this account is here right now. Mounted in the AUTHENTICATED
// layout only: a roster means nothing to a signed-out visitor, and a marketing
// page should not open a cable connection. Core cannot call waldo itself, so
// the roster is resolved here and passed in.
function OnlineNow() {
  const { online, connected } = usePresenceRoster();
  return <PresenceBar members={online} connected={connected} />;
}

export default function Layout({ children }) {
  return (
    <>
      <OnlineNow />
    <AppLayout
      navItems={navItems}
      userInfoLink="/app/profile"
    >
      {children}
    </AppLayout>
    </>
  );
}
